/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type AppDomainsAggregatesModelsOrderByVariable =
  (typeof AppDomainsAggregatesModelsOrderByVariable)[keyof typeof AppDomainsAggregatesModelsOrderByVariable];

export const AppDomainsAggregatesModelsOrderByVariable = {
  alphabetical: 'alphabetical',
  alphabetical_2: 'alphabetical_2',
  n_interactions: 'n_interactions',
  n_users: 'n_users',
  user_feedback_v2: 'user_feedback_v2',
  positive_feedback: 'positive_feedback',
  negative_feedback: 'negative_feedback',
  positive_implicit_feedback: 'positive_implicit_feedback',
  negative_implicit_feedback_v2: 'negative_implicit_feedback_v2',
  positive_explicit_feedback: 'positive_explicit_feedback',
  negative_explicit_feedback: 'negative_explicit_feedback',
  percentage_negative_feedback: 'percentage_negative_feedback',
  conversation_percentage_negative_feedback: 'conversation_percentage_negative_feedback',
  percentage_negative_feedback_explicit: 'percentage_negative_feedback_explicit',
  conversation_percentage_negative_feedback_explicit: 'conversation_percentage_negative_feedback_explicit',
  conversation_positive_feedback: 'conversation_positive_feedback',
  conversation_negative_feedback: 'conversation_negative_feedback',
  n_paste_output: 'n_paste_output',
  trend: 'trend',
  trend_absolute: 'trend_absolute',
  retention: 'retention',
  session_length: 'session_length',
  session_time: 'session_time',
  start_session: 'start_session',
  end_session: 'end_session',
  n_sessions: 'n_sessions',
  n_segments: 'n_segments',
  sentiment_score: 'sentiment_score',
  conversation_sentiment_score: 'conversation_sentiment_score',
  n_positive_messages: 'n_positive_messages',
  n_negative_messages: 'n_negative_messages',
  explicit_feedback_ratio: 'explicit_feedback_ratio',
  bounce_rate: 'bounce_rate',
  timestamp: 'timestamp',
  penetration: 'penetration',
  user_rating: 'user_rating',
  aifi_score: 'aifi_score',
  roi_hours_saved: 'roi_hours_saved',
  roi_hours_saved_per_user: 'roi_hours_saved_per_user',
  roi_hours_saved_per_interaction: 'roi_hours_saved_per_interaction',
  roi_successful_interactions: 'roi_successful_interactions',
  roi_success_rate: 'roi_success_rate',
  roi_value_saved: 'roi_value_saved',
  roi_value_saved_per_interaction: 'roi_value_saved_per_interaction',
  input_tokens: 'input_tokens',
  output_tokens: 'output_tokens',
  input_length: 'input_length',
  output_length: 'output_length',
  cost: 'cost',
  latency_seconds: 'latency_seconds',
  total_users: 'total_users',
  n_user_actions: 'n_user_actions',
  n_intents: 'n_intents',
  potential_savings: 'potential_savings',
  scaled_cost: 'scaled_cost',
} as const;
